<template>
  <div class="text-dist-container">
    <fixed-header-table :fixed="selectedDistribution != null">
      <tr slot="header">
        <th style="flex-grow: 0; justify-content: center;">順位</th>
        <th v-for="yClass in yClasses" :key="yClass">{{`${yName}(集計対象) = ${yClass}`}}</th>
      </tr>
      <tr v-for="(value, valueIndex) in selectedDistribution.values" :key="valueIndex">
        <td style="flex-grow: 0;">{{ value.order+1||number_format}}</td>
        <td
          v-for="(colValue, colIndex) in value.values"
          :key="`${colIndex}_${value.order}_${colValue.word}`"
          class="with-bar-chart"
          :style="getBarChartStyleObj(colValue.count, selectedDistribution.maxAbs)"
        >
          {{colValue.word}}<span class="count-wrapper">&nbsp;({{colValue.count||number_format(0)}}{{valueSuffix}})</span>
        </td>
      </tr>
    </fixed-header-table>

    <div class="column-select-container" v-if="textDistributionResult.length > 1">
      <el-radio v-for="(column, index) in textDistributionResult" v-model="selectedColumnIndex"
                :key="index" name="text-column" :label="index">{{ column.name }}
      </el-radio>
    </div>
  </div>
</template>

<script lang="js">

export default {
  name: 'TextDistributionCmp',
  props: {
    yName: {type: String, default: '集計対象'},
    textDistributionComparison: Object,
    valueSuffix: {type: String, default: ''}
  },
  data () {
    return {
      selectedColumnIndex: -1,
      selectedDistribution: null,
      textDistributionResult: this.textDistributionComparison.results,
      yClasses: this.textDistributionComparison.results[0].value.map(value => value.name)
    }
  },
  computed: {
    getBarChartStyleObj () {
      return function (value, maxAbs = null) {
        const color = value > 0 ? '#cee5ff' : 'rgba(255,161,187,0.62)'

        if (maxAbs !== null) {
          value = Math.abs(value) / maxAbs
        }

        const width = Math.abs(value) * 100
        return {
          background: `linear-gradient(90deg,${color} ${width}%,${color} ${width}%, white ${width}%, white 100%)`
        }
      }
    }
  },
  created () {
    this.selectedColumnIndex = 0
    this.selectedDistribution = this.convertDistribution(this.selectedColumnIndex)
  },
  watch: {
    selectedColumnIndex (newIndex) {
      this.switchDisplay(newIndex)
    }
  },
  methods: {
    switchDisplay (columnIndex) {
      if (columnIndex > -1) {
        this.selectedDistribution = this.convertDistribution(columnIndex)
      }
    },
    convertDistribution (columnIndex) {
      const selectedDistributionResult = this.textDistributionResult[columnIndex]

      let convertedValues = []
      selectedDistributionResult.value.forEach(columnData => {
        const columnValue = columnData.value

        for (let i = 0; i < columnValue.order.length; i++) {
          const order = Number(columnValue.order[i])
          let orderIndex = convertedValues.findIndex(value => value.order === order)
          if (orderIndex === -1) {
            convertedValues.push({
              order: order,
              values: []
            })
            orderIndex = convertedValues.length - 1
          }

          convertedValues[orderIndex].values.push({
            word: columnValue.word[i],
            count: columnValue.count[i]
          })
        }
      })

      return {
        name: selectedDistributionResult.name,
        maxAbs: selectedDistributionResult.maxAbs,
        values: convertedValues
      }
    }
  }
}

</script>

<style scoped>
  .text-dist-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin-top: 8px;
    padding: 8px 20px;
  }

  .text-dist-container > div {
    flex-grow: 1;
  }

  .text-dist-container > div > .table-wrapper {
    max-height: 430px;
    flex-grow: 1;
  }

  .column-select-container {
    padding: 8px 24px 0 24px;
  }

  .with-bar-chart {
    background-clip: content-box;
    padding: 0.5rem 1rem 0.5rem 1rem !important;
  }

  .count-wrapper {
    font-size: 0.8rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/table/text-distribution.vue